import { emailWorkMsg, firstNameMsg, lastNameMsg, mobilePhoneNumberWorkMsg, t } from '../../i18n';
import { FormGridFieldset } from '../FormGridFieldset/FormGridFieldset';
import { Email, Name, PhoneNumber } from '../fields';
import { CostCenter } from '../fields/CostCenter';
import { Reference } from '../fields/Reference';

export const MoveContactFieldset = () => (
  <FormGridFieldset>
    <Name name="firstName" label={t.AIK7(firstNameMsg)} readonly={true} />
    <Name name="lastName" label={t.Y41S(lastNameMsg)} readonly={true} />
    <PhoneNumber label={t.V9K9(mobilePhoneNumberWorkMsg)} />
    <Email label={t.JYZO(emailWorkMsg)} />
    <CostCenter />
    <Reference />
  </FormGridFieldset>
);
